import { format } from 'date-fns';

export const generateString = (
  arr: { id: number; value: Date; label: string; shortLabel: string }[],
) => arr.map((item) => format(item.value, 'MM/dd/yyyy')).join(',');
